import { Component } from '@angular/core';
import { MenuNavExpandedComponent } from '../menu-nav-expanded/menu-nav-expanded.component';

@Component({
    selector: 'app-manage-traveler',
    templateUrl: './manage-traveler.component.html',
    styleUrls: ['./manage-traveler.component.scss'],
    imports: [MenuNavExpandedComponent]
})
export class ManageTravelerComponent {

}
